import { ReactElement } from 'react'
import styled from 'styled-components'
import AlertBanner from 'ui/atoms/AlertBanner'
import { Stack } from 'syf-component-library/ui/spacing'
import i18n from 'lang/i18n'
import { Small } from 'syf-component-library/ui/typography'
import { clientInfo, customComponents, translations } from 'configureBrand'
import { CSRAlertBannerType } from 'typings/brands'

const { CsrAlertContent } = customComponents

export const AlertText = styled.p`
  margin: 16px 0 0;
  padding: 0;
  font-size: 12px;
`

export const BoldText = styled(AlertText)`
  font-weight: 600;
`

export const Banner = styled(AlertBanner)`
  width: 382px;
  max-width: 100%;
  margin: 20px 0 10px;
  & ${AlertText}:first-child {
    margin: 0;
  }
`

export const AlertTitle = styled.p`
  margin: 0;
  font-size: 16px;
`

export const AccessDenied = (): ReactElement => {
  const { isShowOnlineAdministrator } = clientInfo

  return (
    <Banner type="error">
      <Small>
        {i18n({
          login: 'Online Access for this User ID is currently unavailable'
        })}
        {isShowOnlineAdministrator &&
          i18n(
            { csrAlertBanner: 'Please contact online Administrator, or call' },
            {},
            translations
          )}
      </Small>
      <CsrAlertContent i18n={i18n} type={CSRAlertBannerType.ONLINEACCESS} />
    </Banner>
  )
}

export const AccountLockedBanner = () => {
  return (
    <Banner type="error" useLockIcon>
      <AlertTitle>{i18n({ login: 'accountLocked' })}</AlertTitle>
      <Stack size="medium" />
      <Small>{i18n({ login: 'incorrectLoginAttempts' })}</Small>
      <Stack size="medium" />
      <Small>{i18n({ login: 'stepToUnlockUserId' })}</Small>
      <Stack size="medium" />
      <Small>{i18n({ login: 'resetPassword' })}</Small>
      <Stack size="medium" />
      <Small isInline>{i18n({ login: 'administratorLockedOut' })} </Small>
      <CsrAlertContent i18n={i18n} type={CSRAlertBannerType.ACCOUNTLOCK} />
    </Banner>
  )
}
